<template>
  <artmisads-modal
    v-model:open="open"
    :title="t('seller.common.notice')"
    :width="560"
    :footer="null"
    :mask-closable="true"
    @cancel="onClose"
  >
    <p class="notice-text">{{ t('seller.accBonusProgram.accAuthNoticeMsg1') }}</p>
    <p class="notice-text">{{ t('seller.accBonusProgram.accAuthNoticeMsg2') }}</p>
    <p class="notice-text">{{ t('seller.accBonusProgram.accAuthNoticeMsg3') }}</p>
    <div class="notice-actions">
      <artmisads-button type="primary" @click="goAuthorization">
        {{ t('seller.accBonusProgram.goToAuthorizationPage') }}
      </artmisads-button>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const router = useRouter()
const open = ref(false)

const onClose = () => {
  open.value = false
}

const goAuthorization = () => {
  open.value = false
  router.push('/seller/creatorConnections/authorization')
}

const show = () => {
  open.value = true
}

defineExpose({ show })
</script>

<style lang="less" scoped>
.notice-text {
  margin: 0 0 12px;
  font-family: Sora, sans-serif;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.3px;
  color: #0f0629;

  &:last-of-type {
    margin-bottom: 20px;
  }
}

.notice-actions {
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
}
</style>
